import React from 'react'
import UserLoader from './_load/UserLoader'
import PageContent from './PageContent'

const FinancePage = () => {
  return (
    <UserLoader>
      <PageContent />
    </UserLoader>
  )
}

export default FinancePage
